var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',[_vm._v(_vm._s(_vm.label)+" "),_c('input',{attrs:{"type":"radio","id":'abi-'+_vm.name,"disabled":_vm.disabled,"name":_vm.name},domProps:{"checked":_vm.checked,"value":_vm.value}}),_c('span',{staticClass:"checkmark"})])
}
var staticRenderFns = []

export { render, staticRenderFns }